import Vue from "vue";
import * as LDClient from "launchdarkly-js-client-sdk";
import { LDFlagChangeset } from "launchdarkly-js-client-sdk";
import store from "@/store";

// initialize LaunchDarkly with anonomous user
// client ID is not a secret and can be stored in the code per LD docs
const user = store.getters["AuthStore/getLaunchDarklyUser"]["key"]
  ? store.getters["AuthStore/getLaunchDarklyUser"]
  : { anonymous: true };

const _launchDarklyClient = LDClient.initialize(
  "618401e4e330d26355a8e212",
  user
);

_launchDarklyClient.setStreaming(true);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
_launchDarklyClient.on("change", (flags: LDFlagChangeset) => {
  store.commit("AuthStore/setLaunchDarklyFlags", flags);
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function LaunchDarklyPlugin(vue: typeof Vue, options?: any): void {
  vue.prototype.$launchDarkly = _launchDarklyClient;
}

declare module "vue/types/vue" {
  interface Vue {
    $launchDarkly: any;
  }
}

export default LaunchDarklyPlugin;
